/* global $:false */

export default class LotGalleryThumbnail {
  static init () {
    Array.from($('.js-lot-carousel-thumbnail')).map((el) =>
      new LotGalleryThumbnail(el))
  }

  constructor (el) {
    this.el = $(el)
    this.readDataAttributes()
    this.findElements()
    this.setupBindings()
  }

  readDataAttributes () {
    this.id = this.el.data('id')
  }

  findElements () {
    this.carousel = $('.js-lot-carousel')
    this.imageInCarousel = this.carousel.find(`[data-id=${this.id}]`)
  }

  setupBindings () {
    this.el.click(event => this.jumpInCarousel(event))
  }

  jumpInCarousel (event) {
    let position
    event.preventDefault()
    if (this.imageInCarousel.length > 0) {
      position = (this.imageInCarousel.offset().left - this.carousel.offset().left) + this.carousel.scrollLeft()
    } else {
      // Threesixty views are generated dynamically, so JS can't find it.
      // But they are always the first image, so we can assume the position.
      position = 0
    }

    this.carousel.scrollLeft(position)
  }
}
